const excludedAuthPaths = ['/login', '/logout', '/otp/login', '/otp/redirect']

export default defineNuxtRouteMiddleware(async (to: any, _from: any) => {
  const { isLoggedIn } = useUserStore()

  if (to.path === '/login') {
    if (process.client && window.location.hash.includes('user=')) {
      sessionStorage.setItem('azureHash', window.location.hash)
      return
    }
    return
  }

  if (isLoggedIn) {
    await useUserSettingsStore().fetchUserSettings()
  } else if (!excludedAuthPaths.some((path) => to.path.includes(path))) {
    return navigateTo('/login')
  }
})
